<!-- A generic confirm/cancel dialog which executes a function that's passed as a prop -->

<template>
  <v-dialog
    v-model="showDialog"
    fullscreen
    transition="dialog-bottom-transition"
  >
    <v-card style="overflow: hidden">
      <v-row justify="center" class="ma-0 px-2">
        <v-col cols="12" md="9">
          <v-btn class="mb-4" color="primary" @click="onClose">
            {{ $translate('CLOSE') }}
          </v-btn>

          <div class="product-info">
            <ProductOrder
              v-if="showDialog"
              :selectedProduct="product"
              @back="onClose"
            />
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import ProductOrder from '@/components/event/eventDetails/productOrderComponents/ProductOrder';

export default {
  name: 'ProductOrderDialog',
  components: {
    ProductOrder,
  },
  props: {
    showDialog: Boolean,
    product: Object,
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.product-info {
  max-height: calc(
    100vh - 160px
  ); /* 160px is the total height of top and bottom buttons */
  overflow-y: auto;

  @media screen and (min-width: 960px) {
    max-height: none;
  }
}
</style>
